import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { License, LicenseValue, UpgradeLicenseValue } from '../models';

export const licenseActions = createActionGroup({
    source: 'License',
    events: {
        // Get
        'Get License': props<{ id: string }>(),
        'Get License Success': props<{ payload: License }>(),
        'Get License Error': props<{ code: number }>(),
        // Update
        'Update License': props<{ id: string; value: LicenseValue }>(),
        'Update License Success': props<{ payload: License }>(),
        'Update License Error': props<{ code: number }>(),
        // Upgrade
        'Upgrade License': props<{ id: string; value: UpgradeLicenseValue }>(),
        'Upgrade License Success': props<{ payload: License }>(),
        'Upgrade License Error': props<{ code: number }>(),
        // Clear
        Clear: emptyProps(),
    },
});
